import React from 'react';
import './index.scss';
import ShopItem from '../components/shop-item';
import Layout from '../components/layout';
import Logo from '../components/logo';

const itemA = {
    imageUrl: 'a',
    name: 'con calma',
    about: 'organic canvas, `historic` rope and wood pole',
    size: '120x140cm',
    price: 180,
};

const itemB = {
    imageUrl: 'b',
    name: 'bienvenidos',
    about: 'organic canvas, `historic` rope and wood pole',
    size: '120x165cm',
    price: 195,
};

const IndexPage = () => (
    <Layout>
        <div className="indexPage">
            <div className="hero">
                <Logo />
                <div className="stamp" />
            </div>
            <div className="flags">
                <div className="flagRow">
                    <ShopItem {...itemA} />
                    <ShopItem {...itemB} />
                </div>
            </div>
        </div>
    </Layout>
);

export default IndexPage;
